// extracted by mini-css-extract-plugin
module.exports = {"root":"OrdersTable_root__1ZuTf","statusFilter":"OrdersTable_statusFilter__3caZx","alert":"OrdersTable_alert__34lSY","confirmList":"OrdersTable_confirmList__rOG_1"};